import { render, staticRenderFns } from "./DeliveryStepClaimVehicle.vue?vue&type=template&id=85eb47a6&scoped=true&"
import script from "./DeliveryStepClaimVehicle.vue?vue&type=script&lang=js&"
export * from "./DeliveryStepClaimVehicle.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStepClaimVehicle.vue?vue&type=style&index=0&id=85eb47a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eb47a6",
  null
  
)

export default component.exports